var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"mask",rawName:"v-mask",value:(/\d{0,100}/),expression:"/\\d{0,100}/"}],attrs:{"type":"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }